/**
 * Настройки финансового блока, которые решает клиент, а не код:
 * входят ли долги между своими организациями в консолидированный итог.
 *
 * Читаются с сервера один раз за сессию. Пока ответа нет — значение
 * по умолчанию сервера («не включать»), чтобы блок не ждал настройку.
 */

import { useEffect, useState } from 'react'
import { financeApi, onSessionChange, type FinanceSettings } from '../api'

const DEFAULTS: FinanceSettings = { debts_intercompany: 'exclude' }

let loaded: FinanceSettings | null = null
let pending: Promise<FinanceSettings> | null = null

onSessionChange(() => {
  loaded = null
  pending = null
})

/** Сбросить после правки в админке: следующий экран прочитает заново. */
export function forgetFinanceSettings(): void {
  loaded = null
  pending = null
}

export function useFinanceSettings(): { settings: FinanceSettings; ready: boolean } {
  const [value, setValue] = useState<FinanceSettings | null>(loaded)
  useEffect(() => {
    if (loaded) {
      setValue(loaded)
      return
    }
    let cancelled = false
    pending ??= financeApi.settings().catch(() => DEFAULTS)
    void pending.then((result) => {
      loaded = result
      if (!cancelled) setValue(result)
    })
    return () => {
      cancelled = true
    }
  }, [])
  return { settings: value ?? DEFAULTS, ready: value !== null }
}

/** Отчёт долгов уже различает внешних и своих (сервер с миграцией 0023). */
export const RELATION_EXTERNAL = 'Внешние'
export const RELATION_OWN = 'Между своими'
